import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

import './services';

import { Provider } from 'react-redux';
import { ConfigProvider } from './contexts/ConfigContext';

import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
let persistor = persistStore(store)

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);

reportWebVitals();
